export enum AuthProvider {
  Email = 'email',
  Google = 'google',
}

export interface ICNCBrand {
  _id: string;
  name: string;
}

export interface ICNCModel {
  _id: string;
  name: string;
  cncBrand: string;
}

export interface ICNCVariant {
  _id: string;
  name: string;
  cncModel: string;
  cncBrand: string;
}

export interface IOwnedMachine {
  _id: string;
  name: string;
  cncBrand: ICNCBrand;
  cncModel: ICNCModel;
  createdAt: string;
  updatedAt: string;
}

export interface IUser {
  _id: string;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  cncBrand: string[];
  cncModel: string[];
  locatedAt: string;
  profilePicture: string;
  isVerified: boolean;
  isUserSignupComplete: boolean;
  authProvider: AuthProvider;
  ownedMachines: IOwnedMachine[];
  isOnefinityOfficial: boolean;
}

export interface LoginRequest {
  email: string;
  password: string;
}
export interface AuthResponse {
  status: string;
}

export interface IUserSignupData {
  profilePicture?: string | File;
  username: string;
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  cncBrand: string[];
  cncModel: string[];
  cncVariant: string[];
  locatedAt: string;
}

export type UserState = {
  isAuthenticated: boolean;
  isVerified: boolean;
  isLoading: boolean;
  user: IUser | null;
};

export type PasswordChangeRequest = {
  currentPassword: string;
  newPassword: string;
};

export type ICompleteUserSignup = {
  username: string;
  firstname: string;
  lastname: string;
  cncBrand: string[];
  cncModel: string[];
  cncVariant: string[];
  locatedAt: string;
  profilePicture?: string | File;
};
